// app types user role
export const ADMIN = "ADMIN";
export const ECE = "COUNSELOR";
export const TEACHER = "TEACHER";
export const PARENT = "PARENT";
export const STUDENT = "STUDENT";

//rbac rule type

export const PAGES = "page"
export const COMPONENTS = "component"

//modebup comment state

export const COMMENT_OPEN = "OPEN"
export const COMMENT_CLOSED = "CLOSED"